import { Select, SelectClose, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

type Props = {
  onChange: (value: boolean | undefined) => void;
  value: boolean | undefined;
};

const StatusFilter = ({ onChange, value }: Props) => {
  const onClose = () => onChange(undefined);

  const onValueChange = (value: string) => onChange(value === 'true');

  const hasValue = value !== undefined;

  return (
    <div className="relative sm:w-50">
      <Select value={String(value ?? '')} onValueChange={onValueChange}>
        <SelectTrigger withCloseButton={hasValue} className="bg-white w-full">
          <SelectValue placeholder="Filter by status" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="true">Active</SelectItem>
          <SelectItem value="false">Disconnected</SelectItem>
        </SelectContent>
      </Select>
      <SelectClose isVisible={hasValue} onClose={onClose} />
    </div>
  );
};

export default StatusFilter;
